import type { InquiryStatus, InquiryType } from "../drizzle/schema";

export const INQUIRY_TYPE_LABEL: Record<InquiryType, string> = {
  revision: "수정 요청",
  shipping: "배송 문의",
  payment: "결제 문의",
  other: "기타",
};

export const INQUIRY_STATUS_LABEL: Record<InquiryStatus, string> = {
  received: "접수",
  answered: "답변완료",
};

/** Default FAQ (V1). Static on purpose — no admin editing yet. */
export const FAQ_ITEMS: { q: string; a: string }[] = [
  {
    q: "제작 기간은 얼마나 걸리나요?",
    a: "결제 후 이미지 검수를 거쳐 제작이 시작되며, 제작 후 3~5일 안에 출고됩니다. 주문이 몰리는 시기에는 조금 더 걸릴 수 있어요.",
  },
  {
    q: "수정은 몇 번 가능한가요?",
    a: "주문 전에는 작품을 여러 번 다시 만들어 보며 마음에 드는 이미지를 고를 수 있습니다. 주문 후에는 제작이 시작되기 전까지 1:1 문의의 '수정 요청'으로 접수해 주세요. 제작이 시작된 뒤에는 수정이 어려울 수 있습니다.",
  },
  {
    q: "어떤 사진이 잘 나오나요?",
    a: "밝고 초점이 잘 맞는, 해상도가 높은 원본 사진이 가장 좋은 결과를 만듭니다. 인물·반려동물은 얼굴이 또렷하게 보이는 사진을, 풍경은 구도가 안정적인 사진을 추천해요. 어둡거나 흔들린 사진, 작게 줄어든 사진은 큰 사이즈에서 화질이 떨어질 수 있습니다.",
  },
  {
    q: "주문 후 취소/환불은 가능한가요?",
    a: "결제 직후 제작이 시작되기 전(결제완료 상태)에는 마이페이지 주문 상세에서 직접 취소하고 환불받을 수 있습니다. 검수·제작이 시작된 이후에는 맞춤 제작 특성상 취소가 어려울 수 있으니 1:1 문의로 알려 주세요.",
  },
  {
    q: "배송은 얼마나 걸리나요?",
    a: "출고 후 택배사 기준 보통 1~3일 정도 걸립니다. 출고되면 마이페이지 주문 상세에서 택배사와 운송장 번호를 확인할 수 있어요.",
  },
];
